export default __webpack_public_path__ + "static/media/dr-megha-r.f5fab66c.jpg";